import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_14ABlue_22ABlack = () => <CrossRoad coords="2192.000000, 1177.000000"/>;

export default CrossRoad_14ABlue_22ABlack;
